<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative mb-20 md:mb-0 ">
    <Pagesubtitle subTitle="Pass customer information to Feedback Link and we'll automatically send them requests for reviews/feedback."/>

    <!-- PRICING 2026: Developer API is gated on the resolved plan's limits.devAPI
         (false on Free + Learn). Show an upgrade panel instead of the key/endpoints. -->
    <div v-if="!devAPIAllowed" class="text-center">
      <div class="inline-block w-100 my-20">
        <img class="mx-auto w-32" src="@/assets/images/misc/code.png"/>
        <h2 class="my-6">Developer API</h2>
        <p class="my-4 font-medium text-lg">The Developer API is available on the Growth and Engage plans.</p>
        <p class="mb-8 text-dark" v-if="upgradeAllowed">Upgrade to get your API key and integrate Feedback Link with your own systems.</p>
        <p class="mb-8 text-dark" v-else>Ask the account owner to upgrade this account to unlock the Developer API.</p>
        <vs-button v-if="upgradeAllowed" class="w-full" @click="$router.push('/dash/settings/plan')">See Plans</vs-button>
      </div>
    </div>

    <div v-else>
    <div class="my-6 flex items-center">
      <feather-icon icon="InfoIcon" svgClasses="stroke-current text-light w-6 h-6" class="mx-2" />
      <span class="inline-block max-w-lg text-dark font-normal">This page is targeted towards developers, and requires technical knowledge.</span>
    </div>
      <div class="vx-row">
        <!-- CARD 1: CONGRATS -->
        <div class="vx-col w-full lg:w-3/4 mb-base flex">
            <vx-card class="text-left" title="API Key">
              <div class="overflow-auto my-4">
                <vs-input class="float-left w-3/4" readonly :value="$store.getters['dash/devKey']"/>
                <vs-button class="float-left w-1/4" @click="copyKey" type="border" icon-pack="feather" :icon="copyText === 'Copied!' ? 'icon-check':''">{{ copyText }}</vs-button>
              </div>
            </vx-card>
        </div>
      </div>
      <h4>GET Endpoints</h4>
      <p class="my-4">You can send or schedule feedback requests by calling one of our two https GET endpoints.</p>
      <div class="vx-row">
        <div class="vx-col w-full lg:w-3/4 mb-base">
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 mb-base flex">
              <vx-card class="text-left" >
                <div class="pr-4">
                  <h4>
                    <img src="@/assets/images/misc/code.png" class="float-left h-6 my-3 mr-4"/>Send Feedback/Review Request to Customer via Email
                  </h4>
                </div>
                <div class="text-lg">
                  <p class="my-6">Method: GET</p>
                  <div class="my-6">
                    <p class="hdg">Endpoint URL:</p>
                    <p class="desc">
                      <vs-input class="w-full" readonly value="https://feedback.link/api/send-email-invite"/>
                      <vs-button class="inline-block w-full" @click="copyEP1" type="border" icon-pack="feather" :icon="copyTextEP1 === 'Copied!' ? 'icon-check':''">{{ copyTextEP1 }}</vs-button>
                    </p>
                  </div>
                </div>
                <p class="my-4">This action can receive 7 possible GET query parameters:</p>
                <div class="pt_table">
                  <div class="bg-white">
                    <span class="text-dark font-medium">*Required</span>
                    <p class="hdg">api_key</p>
                    <p class="desc">Your API key specified above.</p>
                  </div>
                  <div>
                    <span class="text-dark font-medium">*Required</span>
                    <p class="hdg">customer_email</p>
                    <p class="desc">The email address of the customer to be sent a request.</p>
                  </div>
                  <div class="bg-white">
                    <span>Optional</span>
                    <p class="hdg">customer_first_name</p>
                  </div>
                <div>
                    <span>Optional</span>
                    <p class="hdg">delay_days</p>
                    <p class="desc">The number of days to delay the request with (if needed).</p>
                      <p class="my-4">Accepted values (String):</p>
                      <p class="font-medium my-4">
                          <p>"1 Day", "2 Days", "3 Days", "4 Days", "5 Days", "6 Days", "One week", "8 Days", "9 Days", "10 Days", "2 Weeks", "20 Days", "30 Days"</p>
                      </p>
                </div>
                <div class="bg-white">
                  <span>Optional</span>
                  <p class="hdg">order_number</p>
                  <p class="desc">If you’re connecting your eCommerce platform - you can provide the order number associated with this feedback request. This is shown in your Feedback Link dashboard so you can relate a piece of feedback to an order.</p>
                  <p>Remember to encode this field into valid URL format.</p>
              </div>
              <div>
                  <span>Optional</span>
                  <p class="hdg">reference</p>
                  <p class="desc">(Optional) Shown in your Feedback Link dashboard, so you can relate a piece of feedback to a reference. If you're setting this up for eCommerce, use the "Order Number" field instead.</p>
                  <p>Remember to encode this field into valid URL format.</p>
              </div>
              <div class="bg-white">
                  <span>Optional</span>
                  <p class="hdg">purpose</p>
                  <p class="desc">What the invite asks the customer to do. Accepted values (String): "review" (asks for a public review on your configured platforms) or "referral" (asks them to refer a friend — your referral program must be switched on, otherwise the standard request is sent). Leave out for the standard feedback request.</p>
              </div>
                </div>
              </vx-card>
            </div>
            <div class="vx-col w-full lg:w-1/2 mb-base flex">
              <vx-card class="text-left" >
                <div class="pr-4">
                  <h4>
                    <img src="@/assets/images/misc/code.png" class="float-left h-6 my-3 mr-4"/>Send Feedback/Review Request to Customer via Text/SMS
                  </h4>
                </div>
                <div class="text-lg">
                  <p class="my-6">Method: GET</p>
                  <div class="my-6">
                    <p class="hdg">Endpoint URL:</p>
                    <p class="desc">
                      <vs-input class="w-full" readonly value="https://feedback.link/api/send-text-invite"/>
                      <vs-button class="inline-block w-full" @click="copyEP2" type="border" icon-pack="feather" :icon="copyTextEP2 === 'Copied!' ? 'icon-check':''">{{ copyTextEP2 }}</vs-button>
                    </p>
                  </div>
                </div>
                <p class="my-4">This action can receive 7 possible GET query parameters:</p>
                <div class="pt_table">
                  <div class="bg-white">
                    <span class="text-dark font-medium">*Required</span>
                    <p class="hdg">api_key</p>
                    <p class="desc">Your API key specified above.</p>
                  </div>
                  <div>
                    <span class="text-dark font-medium">*Required</span>
                    <p class="hdg">customer_mobile_number</p>
                    <p class="desc">The mobile number of the customer to be sent a request. Must be formatted in the <a href="https://www.twilio.com/docs/glossary/what-e164" target="_blank">E.164 notation.</a></p>
                  </div>
                  <div class="bg-white">
                    <span>Optional</span>
                    <p class="hdg">customer_first_name</p>
                  </div>
                <div>
                    <span>Optional</span>
                    <p class="hdg">delay_days</p>
                    <p class="desc">The number of days to delay the request with (if needed).</p>
                      <p class="my-4">Accepted values (String):</p>
                      <p class="font-medium my-4">
                          <p>"1 Day", "2 Days", "3 Days", "4 Days", "5 Days", "6 Days", "One week", "8 Days", "9 Days", "10 Days", "2 Weeks", "20 Days", "30 Days"</p>
                      </p>
                </div>
                <div class="bg-white">
                  <span>Optional</span>
                  <p class="hdg">order_number</p>
                  <p class="desc">If you’re connecting your eCommerce platform - you can provide the order number associated with this feedback request. This is shown in your Feedback Link dashboard so you can relate a piece of feedback to an order.</p>
                  <p>Remember to encode this field into valid URL format.</p>
              </div>
              <div>
                  <span>Optional</span>
                  <p class="hdg">reference</p>
                  <p class="desc">(Optional) Shown in your Feedback Link dashboard, so you can relate a piece of feedback to a reference. If you're setting this up for eCommerce, use the "Order Number" field instead.</p>
                  <p>Remember to encode this field into valid URL format.</p>
              </div>
              <div class="bg-white">
                  <span>Optional</span>
                  <p class="hdg">purpose</p>
                  <p class="desc">What the invite asks the customer to do. Accepted values (String): "review" (asks for a public review on your configured platforms) or "referral" (asks them to refer a friend — your referral program must be switched on, otherwise the standard request is sent). Leave out for the standard feedback request.</p>
              </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>


<script>

import Savebutton from './components/ptcomponents/Savebutton.vue'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'

function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(function() {}, function(err) {});
}

export default {
  data () {
    return {
      setupData: false,
      copyText: 'Copy',
      copyTextEP1: 'Copy',
      copyTextEP2: 'Copy'
    }
  },
  methods: {
    copyKey () {
      copyTextToClipboard(this.$store.getters['dash/devKey'])
      this.copyText = 'Copied!'
    },
    copyEP1 () {
      copyTextToClipboard('https://feedback.link/api/send-email-invite')
      this.copyTextEP1 = 'Copied!'
    },
    copyEP2 () {
      copyTextToClipboard('https://feedback.link/api/send-text-invite')
      this.copyTextEP2 = 'Copied!'
    }
  },
  computed: {
    //PRICING 2026: Developer API key/endpoints only on plans where limits.devAPI is true
    devAPIAllowed () {
      return !!this.$store.getters['dash/planResolved'].limits.devAPI
    },
    //hide the upgrade CTA for collaborators and agency-managed accounts
    upgradeAllowed () {
      if (this.$store.getters['dash/isCollaborator']) return false
      return this.$store.state.dash.viewData.business.upgradeCTAVisible !== false
    }
  },
  components: {
    Savebutton,
    Pagesubtitle
  },
  created () {
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
